// src/ui/themes.ts
import '../styles/theme-default.css';
import '../styles/theme-acid.css';
import '../styles/theme-light.css';

export type ThemeId = 'default' | 'acid' | 'light';
export const THEMES: { id: ThemeId; label: string }[] = [
  { id: 'default', label: 'Dark Blue' },
  { id: 'acid',    label: 'Acid Green' },
  { id: 'light',   label: 'Light' },
];

const KEY = 'dither-web/theme';

export function loadTheme(): ThemeId {
  const v = localStorage.getItem(KEY) as ThemeId | null;
  return v && THEMES.some(t => t.id === v) ? v : 'default';
}

export function applyTheme(theme: ThemeId) {
  document.documentElement.dataset.theme = theme;
  localStorage.setItem(KEY, theme);
}
